import React from 'react';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { H4, NamedLink } from '../../components';
import css from './ProfilePage.module.css';

const SectionCollaboratorProfile = props => {
  const { publicData, intl } = props;
  const {
    projectName,
    collaborationType,
    collaboratorWebsite,
    operatingLocation,
    collaborationMessage,
  } = publicData || {};

  const hasCollaboratorInfo = projectName || collaborationType || collaboratorWebsite || operatingLocation || collaborationMessage;

  if (!hasCollaboratorInfo) {
    return null;
  }

  const formatCollaborationTypes = (types) => {
    if (!types || types.length === 0) return null;
    return types.map(type => intl.formatMessage({ id: `ProfilePage.collaboratorProfile.${type}` })).join(', ');
  };

  return (
    <div className={css.collaboratorProfileSection}>
      <div className={css.headerWithBadge}>
        <H4 as="h2" className={css.sectionTitle}>
          <FormattedMessage id="ProfilePage.collaboratorProfile.title" />
        </H4>
        {publicData?.voluntaryAgreement && (
          <div className={css.organicBadge} style={{ background: 'var(--colorSuccess)', boxShadow: 'none' }}>
            <span className={css.badgeIcon}>🤝</span>
            <span>Volunteer</span>
          </div>
        )}
      </div>
      
      <div className={css.collaboratorInfo}>
        {projectName && (
          <div className={css.infoRow}>
            <span className={css.infoLabel}>
              <FormattedMessage id="ProfilePage.collaboratorProfile.projectName" />:
            </span>
            <span className={css.infoValue}>{projectName}</span>
          </div>
        )}

        {collaborationType && collaborationType.length > 0 && (
          <div className={css.infoRow}>
            <span className={css.infoLabel}>
              <FormattedMessage id="ProfilePage.collaboratorProfile.collaborationType" />:
            </span>
            <span className={css.infoValue}>{formatCollaborationTypes(collaborationType)}</span>
          </div>
        )}

        {operatingLocation && (
          <div className={css.infoRow}>
            <span className={css.infoLabel}>
              <FormattedMessage id="ProfilePage.collaboratorProfile.operatingLocation" />:
            </span>
            <span className={css.infoValue}>{operatingLocation?.address || operatingLocation}</span>
          </div>
        )}

        {collaboratorWebsite && (
          <div className={css.infoRow}>
            <span className={css.infoLabel}>
              <FormattedMessage id="ProfilePage.collaboratorProfile.website" />:
            </span>
            <span className={css.infoValue}>
              <a href={collaboratorWebsite} target="_blank" rel="noopener noreferrer" className={css.socialLink}>
                {collaboratorWebsite}
              </a>
            </span>
          </div>
        )}

        {collaborationMessage && (
          <div className={css.infoRow} style={{ flexDirection: 'column', marginTop: '16px' }}>
            <span className={css.infoLabel} style={{ marginBottom: '8px' }}>
              <FormattedMessage id="ProfilePage.collaboratorProfile.message" />:
            </span>
            <span className={css.infoValue}>
              <div className={css.miniSlogan} style={{ margin: 0 }}>
                <em>"{collaborationMessage}"</em>
              </div>
            </span>
          </div>
        )}
      </div>

      <div className={css.collaboratorActions}>
        <NamedLink className={css.actionButton} name="SearchPage" to={{ search:"address=Espa%C3%B1a&bounds=28.08136788%2C-15.4942265%2C27.93951364%2C-15.62583784&mapSearch=true" }}>
          <FormattedMessage id="ProfilePage.collaboratorProfile.findPartners" />
        </NamedLink>
      </div>
    </div>
  );
};

export default SectionCollaboratorProfile;
